import { Dialog } from 'primereact/dialog';
import { useEffect, useRef, useState } from 'react';
import { GenericComponent } from '../../components/GenericComponent';
import { InputComponent } from '../../components/InputComponent';
import { FormaPago } from '../../models/FormaPago';
import { FormaPagoService } from '../../service/FormaPagoService';
import { useForm } from 'react-hook-form';
import { confirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Column } from 'primereact/column';
import { Menu } from 'primereact/menu';
import { TablaDinamica } from '../../components/TablaDinamica';
import { useLazyParams } from '../../hooks/useLazyParams';
import { Message } from 'primereact/message';

export const Pago = ({ toast, tipo, id, permss, soloLectura, tipoFrmEmpresa }) => {

    const generic = new GenericComponent();
    const omodel = new FormaPago({ tipoFrmEmpresa });
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues });
    const formaPagoService = new FormaPagoService();
    const [dialogPago, setDialogPago] = useState(false);
    const [catalogos, setCatalogos] = useState(null);
    const [pagoSeleccionado, setPagoSeleccionado] = useState(null);
    const menuRef = useRef(null);
    const [siDetalle, setSiDetalle] = useState(false);
    const tablaPago = useLazyParams({ modelo: omodel.model });
    const { inDrop, inNumber, inText } = InputComponent({ registers: tablaPago.data, omodel, generic, errors, control, id: getValues('id'), permss, soloLectura });

    useEffect(() => {
        if (id) loadLazyDataPago();
        // eslint-disable-next-line
    }, [tablaPago.lazyParams, id]);

    const loadLazyDataPago = () => {
        tablaPago.setLoading(true);
        const _params = { ...tablaPago.lazyParams, idp: id, tipo: tipo };
        formaPagoService.getFormaPago({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaPago.setTotalRecords(res.data.total);
            tablaPago.setData(res.data.registros);
        }).finally(() => tablaPago.setLoading(false));
    }

    const openNew = () => {
        if (catalogos == null) {
            formaPagoService.newFormaPago({ iniciar: 1, tipoFrmEmpresa, tipo }).then(res => {
                setCatalogos(res.data);
                setDialogPago(true);
                setSiDetalle(false);
                reset(defaultValues);
            });
        }
        else {
            setDialogPago(true);
            reset(defaultValues);
            setSiDetalle(false);
        }
    }

    const onSubmit = (data) => {
        data.idp = id;
        data.tipo = tipo;
        data.tipoFrmEmpresa = tipoFrmEmpresa;

        const request = getValues('id') == null ? formaPagoService.newFormaPago(data) : formaPagoService.editarFormaPago(data);
        request.then(res => {
            setDialogPago(false);
            loadLazyDataPago();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        });
    }

    const editPago = () => {
        const iniciar = catalogos == null ? 1 : 0;
        formaPagoService.getPago(pagoSeleccionado?.id, iniciar, { tipoFrmEmpresa, tipo }).then(res => {
            const _cats = catalogos ?? res.data.catalogo;
            if (iniciar === 1) {
                setCatalogos(res.data.catalogo);
            }
            const _pago = res.data.pago;
            setSiDetalle(tipoFrmEmpresa === 'FRM_TOYOTA' && JSON.stringify(_pago.tipo_pago) === JSON.stringify(_cats.otros));

            reset(_pago);
            setDialogPago(true);
        });
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminarPago()
        });
    }

    const eliminarPago = () => {
        formaPagoService.eliminar(pagoSeleccionado?.id, id, tipo).then(res => {
            loadLazyDataPago();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Por favor revise los campos del formulario', life: 3000 });
    }

    const itemsMenu = () => {
        if (soloLectura) {
            return [{ label: 'Opciones', items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editPago() }] }];
        }

        const items = [];
        if (permss?.actualizar) items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => editPago() });
        if (permss?.eliminar) items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete() });
        return [{ label: 'Opciones', items: items }];
    }

    const accionesTemplate = (rowData) => (
        <Button
            icon="pi pi-caret-down"
            type="button"
            className="p-button-rounded p-button-success mr-2"
            title="Opciones/Acciones"
            aria-controls="popup_menu_pago"
            aria-haspopup
            onClick={(e) => { setPagoSeleccionado(rowData); menuRef.current.toggle(e); }}
        />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de Formas de Pago {tipoFrmEmpresa === 'FRM_TOYOTA' && !['juridica'].includes(tipo) && ' - Pago inicial'}
            </span>
        </div>
    );

    const onChangeTipoPago = (e) => {
        if (tipoFrmEmpresa === 'FRM_TOYOTA') {
            setSiDetalle(JSON.stringify(e.value) === JSON.stringify(catalogos?.otros));
            setValue('detalle', '');
        }
    }

    return (
        <>
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_pago" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaPago} datos={tablaPago.data} totalRegistros={tablaPago.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />

            <Dialog visible={dialogPago} header={soloLectura ? "Ver Forma de Pago" : (getValues('id') == null ? "Nueva Forma de pago" : "Editar Forma de Pago")} modal
                className="p-fluid modal-ssize" onHide={() => setDialogPago(false)}>
                <form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit, onError)(e); }}>
                    <div className="col-12 mb-3">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-wallet text-primary"></i>
                                FORMA DE PAGO
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>

                    <Card className="mb-3 section-card">
                        <div className="formgrid grid">
                            {inDrop('tipo_pago', catalogos?.tipo, { lab: omodel.optionLabel, chn: onChangeTipoPago }, 12)}
                            {inNumber('valor', 2, true, {}, 12)}
                            {siDetalle && inText('detalle', {}, 12)}
                        </div>
                    </Card>

                    {soloLectura ? (
                        <div className="flex justify-content-end mt-3">
                            <Button label="Cerrar" icon="pi pi-times" type="button" className="p-button-warning" onClick={() => setDialogPago(false)} />
                        </div>
                    ) : (
                        generic.buttonsForms(setDialogPago)
                    )}
                </form>
            </Dialog>
        </>
    )
}
